export const BUILDER_MARKER_START = "<!--PAGE_BUILDER_JSON:";
export const BUILDER_MARKER_END = ":END_PAGE_BUILDER_JSON-->";

export const PAGE_MAX_WIDTH_CLASS = "mx-auto w-full max-w-[1100px] px-4";

export const BLOCK_TYPES = [
  { value: "title", label: "Titre" },
  { value: "subtitle", label: "Sous-titre" },
  { value: "paragraph", label: "Paragraphe" },
  { value: "image", label: "Image" },
  { value: "button", label: "Bouton" },
  { value: "info", label: "Encart information" },
  { value: "quote", label: "Citation" },
  { value: "twoColumns", label: "Deux colonnes" },
  { value: "cards", label: "Cartes" },
  { value: "divider", label: "Séparateur" },
];

export const BLOCK_LABELS = {
  title: "Titre",
  subtitle: "Sous-titre",
  paragraph: "Paragraphe",
  image: "Image",
  button: "Bouton",
  info: "Encart information",
  quote: "Citation",
  twoColumns: "Deux colonnes",
  cards: "Cartes",
  divider: "Séparateur",
  legacyHtml: "Ancien contenu HTML",
};

export const newId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
};

export const getDefaultPageBlocks = () => [
  {
    id: newId(),
    type: "title",
    content: "Titre de votre section",
    align: "left",
  },
  {
    id: newId(),
    type: "paragraph",
    content:
      "Présentez ici les informations importantes de votre page.\n\nVous pouvez ajouter ensuite une image, un bouton, un encart d’information ou des cartes.",
  },
];

export const newBlock = (type = "paragraph") => {
  switch (type) {
    case "title":
      return {
        id: newId(),
        type: "title",
        content: "Titre de votre section",
        align: "left",
      };

    case "subtitle":
      return {
        id: newId(),
        type: "subtitle",
        content: "Votre sous-titre",
        align: "left",
      };

    case "paragraph":
      return {
        id: newId(),
        type: "paragraph",
        content: "Votre paragraphe ici.",
      };

    case "image":
      return {
        id: newId(),
        type: "image",
        src: "",
        alt: "",
        caption: "",
        size: "wide",
        ratio: "auto",
        fit: "cover",
        cropX: 50,
        cropY: 50,
      };

    case "button":
      return {
        id: newId(),
        type: "button",
        label: "En savoir plus",
        url: "#",
        align: "center",
        style: "primary",
      };

    case "info":
      return {
        id: newId(),
        type: "info",
        title: "Information importante",
        content: "Ajoutez ici une information à mettre en avant.",
        tone: "blue",
      };

    case "quote":
      return {
        id: newId(),
        type: "quote",
        content: "Votre citation ou phrase à mettre en avant.",
        author: "",
      };

    case "twoColumns":
      return {
        id: newId(),
        type: "twoColumns",
        title: "",
        leftTitle: "Colonne gauche",
        leftText: "Texte de la colonne gauche.",
        leftImage: "",
        leftImageAlt: "",
        rightTitle: "Colonne droite",
        rightText: "Texte de la colonne droite.",
        rightImage: "",
        rightImageAlt: "",
      };

    case "cards":
      return {
        id: newId(),
        type: "cards",
        title: "Titre de la section",
        subtitle: "",
        columns: 3,
        items: [
          {
            title: "Carte 1",
            text: "Description courte.",
            image: "",
            imageAlt: "",
            imageRatio: "16-9",
            imageFit: "contain",
            imageCropX: 50,
            imageCropY: 50,
            linkLabel: "",
            linkUrl: "",
          },
          {
            title: "Carte 2",
            text: "Description courte.",
            image: "",
            imageAlt: "",
            imageRatio: "16-9",
            imageFit: "contain",
            imageCropX: 50,
            imageCropY: 50,
            linkLabel: "",
            linkUrl: "",
          },
          {
            title: "Carte 3",
            text: "Description courte.",
            image: "",
            imageAlt: "",
            imageRatio: "16-9",
            imageFit: "contain",
            imageCropX: 50,
            imageCropY: 50,
            linkLabel: "",
            linkUrl: "",
          },
        ],
      };

    case "divider":
      return {
        id: newId(),
        type: "divider",
      };

    default:
      return {
        id: newId(),
        type: "paragraph",
        content: "Votre texte ici.",
      };
  }
};

const normalizeCardItem = (item = {}) => ({
  ...item,
  title: item.title || "",
  text: item.text || "",
  image: item.image || "",
  imageAlt: item.imageAlt || "",
  imageRatio: item.imageRatio || "16-9",
  imageFit: item.imageFit || "contain",
  imageCropX: Number.isFinite(Number(item.imageCropX))
    ? Number(item.imageCropX)
    : 50,
  imageCropY: Number.isFinite(Number(item.imageCropY))
    ? Number(item.imageCropY)
    : 50,
  linkLabel: item.linkLabel || "",
  linkUrl: item.linkUrl || "",
});

export const normalizeBlocks = (blocks = []) => {
  if (!Array.isArray(blocks)) return [];

  return blocks.filter(Boolean).map((block) => {
    const normalized = {
      ...block,
      id: block.id || newId(),
      type: block.type || "paragraph",
      ratio: block.type === "image" ? block.ratio || "auto" : block.ratio,
      fit: block.type === "image" ? block.fit || "cover" : block.fit,
      cropX:
        block.type === "image"
          ? Number.isFinite(Number(block.cropX))
            ? Number(block.cropX)
            : 50
          : block.cropX,
      cropY:
        block.type === "image"
          ? Number.isFinite(Number(block.cropY))
            ? Number(block.cropY)
            : 50
          : block.cropY,
    };

    if (normalized.type === "cards") {
      normalized.items = Array.isArray(normalized.items)
        ? normalized.items.map(normalizeCardItem)
        : [];
    }

    return normalized;
  });
};

export const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export const escapeAttr = (value = "") =>
  escapeHtml(value).replace(/"/g, "&quot;");

const safeNumber = (value, fallback = 50) => {
  const n = Number(value);

  if (!Number.isFinite(n)) return fallback;

  return Math.min(Math.max(n, 0), 100);
};

const alignClass = (align = "left") => {
  if (align === "center") return "text-center";
  if (align === "right") return "text-right";
  return "text-left";
};

const buttonAlignClass = (align = "center") => {
  if (align === "left") return "text-left";
  if (align === "right") return "text-right";
  return "text-center";
};

const buttonStyleClass = (style = "primary") => {
  if (style === "secondary") {
    return "border border-slate-300 bg-white text-slate-800 hover:bg-slate-50";
  }

  if (style === "dark") {
    return "bg-slate-950 text-white hover:bg-slate-800";
  }

  return "bg-sky-600 text-white hover:bg-sky-700";
};

const imageSizeClass = (size = "wide") => {
  if (size === "small") return "max-w-[620px]";
  if (size === "medium") return "max-w-[820px]";
  return "max-w-[1100px]";
};

const infoToneClass = (tone = "blue") => {
  if (tone === "green") {
    return "border-emerald-200 bg-emerald-50 text-emerald-950";
  }

  if (tone === "amber") {
    return "border-amber-200 bg-amber-50 text-amber-950";
  }

  if (tone === "rose") {
    return "border-rose-200 bg-rose-50 text-rose-950";
  }

  return "border-sky-200 bg-sky-50 text-sky-950";
};

const gridClass = (columns = 3) => {
  const cols = Number(columns);

  if (cols === 2) return "md:grid-cols-2";
  if (cols === 4) return "md:grid-cols-2 xl:grid-cols-4";

  return "md:grid-cols-2 xl:grid-cols-3";
};

const getAspectRatio = (ratio = "auto") => {
  switch (ratio) {
    case "square":
      return "1 / 1";

    case "16-9":
      return "16 / 9";

    case "4-3":
      return "4 / 3";

    case "3-2":
      return "3 / 2";

    case "4-5":
      return "4 / 5";

    case "3-4":
      return "3 / 4";

    default:
      return "";
  }
};

const textToParagraphs = (value = "", extraClass = "") => {
  const text = String(value || "").trim();

  if (!text) return "";

  return text
    .split(/\n{2,}/)
    .map((paragraph) => {
      const html = escapeHtml(paragraph.trim()).replace(/\n/g, "<br/>");

      return `<p class="${extraClass}">${html}</p>`;
    })
    .join("\n");
};

const renderImageElement = ({
  src,
  alt = "",
  ratio = "auto",
  fit = "cover",
  cropX = 50,
  cropY = 50,
  imageClass = "",
}) => {
  if (!src) return "";

  const finalFit = fit === "contain" ? "contain" : "cover";
  const finalX = safeNumber(cropX);
  const finalY = safeNumber(cropY);
  const aspectRatio = getAspectRatio(ratio);

  if (aspectRatio) {
    return `
<div
  class="overflow-hidden rounded-[28px] border border-slate-200 bg-slate-100 shadow-sm ${imageClass}"
  style="aspect-ratio:${aspectRatio};"
>
  <img
    src="${escapeAttr(src)}"
    alt="${escapeAttr(alt)}"
    class="h-full w-full"
    style="object-fit:${finalFit};object-position:${finalX}% ${finalY}%;"
  />
</div>`;
  }

  return `
<img
  src="${escapeAttr(src)}"
  alt="${escapeAttr(alt)}"
  class="h-auto max-h-[620px] w-full rounded-[28px] border border-slate-200 object-cover shadow-sm ${imageClass}"
  style="object-fit:${finalFit};object-position:${finalX}% ${finalY}%;"
/>`;
};

const renderTitle = (block) => {
  if (!block.content) return "";

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-8 ${alignClass(block.align)}">
  <h2 class="text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">
    ${escapeHtml(block.content)}
  </h2>
</section>`;
};

const renderSubtitle = (block) => {
  if (!block.content) return "";

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-4 ${alignClass(block.align)}">
  <h3 class="text-xl font-bold tracking-tight text-slate-800 md:text-2xl">
    ${escapeHtml(block.content)}
  </h3>
</section>`;
};

const renderParagraph = (block) => {
  if (!block.content) return "";

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-5">
  <div class="mx-auto max-w-[850px] space-y-4 text-base leading-8 text-slate-700 md:text-lg">
    ${textToParagraphs(block.content)}
  </div>
</section>`;
};

const renderImage = (block) => {
  if (!block.src) return "";

  return `
<figure class="mx-auto w-full ${imageSizeClass(block.size)} px-4 py-7">
  ${renderImageElement({
    src: block.src,
    alt: block.alt,
    ratio: block.ratio,
    fit: block.fit,
    cropX: block.cropX,
    cropY: block.cropY,
  })}
  ${
    block.caption
      ? `<figcaption class="mt-3 text-center text-sm text-slate-500">${escapeHtml(
          block.caption,
        )}</figcaption>`
      : ""
  }
</figure>`;
};

const renderButton = (block) => {
  if (!block.label || !block.url) return "";

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-7 ${buttonAlignClass(block.align)}">
  <a
    href="${escapeAttr(block.url)}"
    class="inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-bold shadow-sm transition ${buttonStyleClass(
      block.style,
    )}"
  >
    ${escapeHtml(block.label)}
  </a>
</section>`;
};

const renderInfo = (block) => {
  const hasTitle = Boolean(block.title);
  const hasContent = Boolean(block.content);

  if (!hasTitle && !hasContent) return "";

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-6">
  <div class="mx-auto max-w-[850px] rounded-[28px] border p-6 shadow-sm ${infoToneClass(
    block.tone,
  )}">
    ${
      hasTitle
        ? `<h3 class="text-lg font-bold tracking-tight">${escapeHtml(
            block.title,
          )}</h3>`
        : ""
    }
    ${
      hasContent
        ? `<div class="mt-3 space-y-3 text-sm leading-7 md:text-base">
            ${textToParagraphs(block.content)}
          </div>`
        : ""
    }
  </div>
</section>`;
};

const renderQuote = (block) => {
  if (!block.content) return "";

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-8">
  <blockquote class="mx-auto max-w-[850px] rounded-[28px] border-l-4 border-sky-500 bg-white p-6 text-xl font-medium leading-9 text-slate-800 shadow-sm">
    “${escapeHtml(block.content)}”
    ${
      block.author
        ? `<footer class="mt-4 text-sm font-bold text-slate-500">— ${escapeHtml(
            block.author,
          )}</footer>`
        : ""
    }
  </blockquote>
</section>`;
};

const renderTwoColumns = (block) => {
  const hasTitle = Boolean(block.title);

  const renderColumn = ({ title, text, image, imageAlt }) => `
    <article class="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
      ${
        image
          ? `<img src="${escapeAttr(image)}" alt="${escapeAttr(
              imageAlt || "",
            )}" class="mb-4 h-56 w-full rounded-2xl object-cover" />`
          : ""
      }
      ${
        title
          ? `<h3 class="text-xl font-bold tracking-tight text-slate-950">${escapeHtml(
              title,
            )}</h3>`
          : ""
      }
      ${
        text
          ? `<div class="mt-3 space-y-3 text-sm leading-7 text-slate-600 md:text-base">${textToParagraphs(
              text,
            )}</div>`
          : ""
      }
    </article>
  `;

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-10">
  ${
    hasTitle
      ? `<h2 class="mb-6 text-2xl font-bold tracking-tight text-slate-950 md:text-3xl">${escapeHtml(
          block.title,
        )}</h2>`
      : ""
  }

  <div class="grid gap-6 md:grid-cols-2">
    ${renderColumn({
      title: block.leftTitle,
      text: block.leftText,
      image: block.leftImage,
      imageAlt: block.leftImageAlt,
    })}
    ${renderColumn({
      title: block.rightTitle,
      text: block.rightText,
      image: block.rightImage,
      imageAlt: block.rightImageAlt,
    })}
  </div>
</section>`;
};

const renderCards = (block) => {
  const items = Array.isArray(block.items) ? block.items : [];

  if (!block.title && items.length === 0) return "";

  const cards = items
    .map((item) => {
      const hasLink = item.linkLabel && item.linkUrl;

      const imageHtml = item.image
        ? `
  <div class="bg-slate-50 p-3">
    ${renderImageElement({
      src: item.image,
      alt: item.imageAlt || item.title || "",
      ratio: item.imageRatio || "16-9",
      fit: item.imageFit || "contain",
      cropX: item.imageCropX,
      cropY: item.imageCropY,
      imageClass: "rounded-2xl shadow-none",
    })}
  </div>`
        : "";

      return `
<article class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
  ${imageHtml}

  <div class="p-5">
    ${
      item.title
        ? `<h3 class="text-lg font-bold tracking-tight text-slate-950">${escapeHtml(
            item.title,
          )}</h3>`
        : ""
    }

    ${
      item.text
        ? `<p class="mt-2 text-sm leading-7 text-slate-600">${escapeHtml(
            item.text,
          )}</p>`
        : ""
    }

    ${
      hasLink
        ? `<a href="${escapeAttr(
            item.linkUrl,
          )}" class="mt-4 inline-flex items-center rounded-full bg-sky-600 px-4 py-2 text-sm font-bold text-white transition hover:bg-sky-700">${escapeHtml(
            item.linkLabel,
          )}</a>`
        : ""
    }
  </div>
</article>`;
    })
    .join("\n");

  return `
<section class="${PAGE_MAX_WIDTH_CLASS} py-10">
  ${
    block.title
      ? `<h2 class="text-2xl font-bold tracking-tight text-slate-950 md:text-3xl">${escapeHtml(
          block.title,
        )}</h2>`
      : ""
  }

  ${
    block.subtitle
      ? `<p class="mt-2 max-w-3xl text-slate-600">${escapeHtml(
          block.subtitle,
        )}</p>`
      : ""
  }

  <div class="mt-6 grid gap-6 ${gridClass(block.columns)}">
    ${cards}
  </div>
</section>`;
};

const renderDivider = () => `
<section class="${PAGE_MAX_WIDTH_CLASS} py-8">
  <hr class="border-slate-200" />
</section>`;

const renderLegacyHtml = (block) => {
  return block.html || "";
};

export const renderBlockToHtml = (block) => {
  if (!block) return "";

  switch (block.type) {
    case "title":
      return renderTitle(block);

    case "subtitle":
      return renderSubtitle(block);

    case "paragraph":
      return renderParagraph(block);

    case "image":
      return renderImage(block);

    case "button":
      return renderButton(block);

    case "info":
      return renderInfo(block);

    case "quote":
      return renderQuote(block);

    case "twoColumns":
      return renderTwoColumns(block);

    case "cards":
      return renderCards(block);

    case "divider":
      return renderDivider(block);

    case "legacyHtml":
      return renderLegacyHtml(block);

    default:
      return "";
  }
};

export const buildBuilderMarker = (blocks = []) => {
  try {
    const json = JSON.stringify(normalizeBlocks(blocks));
    return `${BUILDER_MARKER_START}${encodeURIComponent(
      json,
    )}${BUILDER_MARKER_END}`;
  } catch {
    return "";
  }
};

export const buildPageHtml = (blocks = [], options = {}) => {
  const { includeMarker = true } = options;

  const normalized = normalizeBlocks(blocks);
  const body = normalized.map(renderBlockToHtml).join("\n");

  if (!includeMarker) return body;

  return `${buildBuilderMarker(normalized)}\n${body}`;
};

export const extractBuilderBlocks = (contentHtml = "") => {
  const source = String(contentHtml || "");

  const regex = /<!--PAGE_BUILDER_JSON:([\s\S]*?):END_PAGE_BUILDER_JSON-->/m;

  const match = source.match(regex);

  if (!match?.[1]) return null;

  try {
    const decoded = decodeURIComponent(match[1]);
    const parsed = JSON.parse(decoded);

    return Array.isArray(parsed) ? normalizeBlocks(parsed) : null;
  } catch {
    return null;
  }
};

export const stripBuilderMarker = (contentHtml = "") => {
  return String(contentHtml || "")
    .replace(/<!--PAGE_BUILDER_JSON:([\s\S]*?):END_PAGE_BUILDER_JSON-->/m, "")
    .trim();
};
